import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

export const listBoxHeight = css`
  max-height: 22.4rem;
`;

export const classes = {
  listbox: cn('p-8', listBoxHeight),
};
